<template>
	<div>
		<v-list>
			<RecordingListItem v-for="room in rooms" :key="room.id" :room="room" :project="project"></RecordingListItem>
		</v-list>
	</div>

</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import RecordingListItem from "./RecordingListItem"
	export default {
		name: "ProjectRecordings", 
		props: {
			project: {type: Object}
		},
		data: () => {
			return {
				dialog: false, 
				downloading: false 
			}
		},
		components: {
			RecordingListItem
		},
		computed: {
			...Vuex.mapState({
				appointments(state){ 
					var pid = this.project.id;
					return state[state.auth.view].appointments.filter( a => a.project == pid )
				},
				user: state => state.auth.user, 
				panelists: state => state[state.auth.view].panelists,
				videoCompositions(state){
					return state[state.auth.view].videoCompositions;
				}
			}), 
			rooms(){
				const self = this;
				var appointments = self.appointments.filter( a => a.videoMeeting );
				var rooms = [];
				appointments.filter(a => a.videoMeeting.roomSids).forEach( a => {
					a.videoMeeting.roomSids.forEach( r => {
						var room = {appointment: a.id };
						room.roomSid = r;
						room.participant = self.panelists.find( p => p.id == a.participant);
						room.dateTime = a.dateTime;
						room.id = a.id + r.id;
						room.composition = self.videoCompositions.find( v => v.roomSid == r )
						rooms.push( room )
					})

				})
				return rooms;
			}
		},
		watch: {
			appointments: {
				immediate: true,
				handler(){				
					const self = this;
					self.appointments.forEach( a => {
						self.$store.dispatch("fetchVideoCompositions", a.id )
					})
				}
			}
		},
		methods: {
		}
		// created(){
			
		// }

	}
// </script>"